import _ from 'lodash'
import FieldGroupFormatter from './FieldGroupFormatter';

class CriteriaScreen extends FieldGroupFormatter {
  
  formatFieldsToScreen(fields, valueFieldType) {
    _.each(fields, (field) => {
      field.fieldType = valueFieldType
      field.field = field.cac_codigo
      field.type = this.formatType(field.cac_tipocampo)
      delete field.cac_codigo
      delete field.cac_tipocampo
    })
    return fields
  }

}

export default new CriteriaScreen